import type { EngagementPoints } from "@um/contracts";

/** Point values for engagement events (backend uses these; frontend uses for display/feedback timing). */
export const ENGAGEMENT_POINT_VALUES = {
  completedMind: 5,
  activityResponse: 1,
  mindCount: 2,
  characterCount: 1,
} as const;

export type EngagementEventType = keyof typeof ENGAGEMENT_POINT_VALUES;

/**
 * Compute total engagement points from account.stats.engagementPoints (used for feedback-form timing).
 * Points are added by the backend; the app only reads them.
 */
export function totalEngagementPoints(
  engagementPoints?: Partial<EngagementPoints> | null
): number {
  if (!engagementPoints) return 0;
  if (typeof engagementPoints.totalPoints === "number") {
    return engagementPoints.totalPoints;
  }
  return (
    (engagementPoints.completedMind ?? 0) +
    (engagementPoints.activityResponse ?? 0) +
    (engagementPoints.mindCount ?? 0) +
    (engagementPoints.characterCount ?? 0)
  );
}
